exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploaded-icon[data-v-1b66d854]{width:100px;height:100px;-o-object-fit:cover;object-fit:cover}.rule-extra-panel[data-v-1b66d854]{margin-top:12px;padding:16px;background-color:#f9f9f9;border:1px dashed #dcdfe6;border-radius:4px}", ""]);

// exports
